import { useMemo } from "react";
import "../theme/Indicadores.css";
import numbro from "numbro";

import { icons } from "../const/icons";
import { SkeletonSalesCard } from "./SkeletonSalesCard";

export const TableSales = ({ salesData, isLoading = false, hasError = false }) => {
  const calculations = useMemo(() => {
    // Si no hay datos o hay error, retornar valores en cero
    if (!salesData || hasError) {
      return {
        ventaReal: "0.0",
        ventaPtto: "0.0",
        ventaCuota: "0.0",
        ventaAA: "0.0",
        ventaPttoAvg: 0,
        ventaCuotaAvg: 0,
        ventaAAAvg: 0,
      };
    }

    const {
      fnventa_real = 0,
      fnventa_ppto = 0,
      fncuota_ventas = 0,
      fnventa_real_aa = 0,
    } = salesData;

    const formatValue = (value) =>
      value === 0 ? "0.0" : numbro(value).format({ thousandSeparated: true, mantissa: 1 });

    const calcPercentage = (real, compare) =>
      compare === 0 ? 0 : Math.round((real * 100) / compare);

    return {
      ventaReal: formatValue(fnventa_real),
      ventaPtto: formatValue(fnventa_ppto),
      ventaCuota: formatValue(fncuota_ventas),
      ventaAA: formatValue(fnventa_real_aa),
      ventaPttoAvg: calcPercentage(fnventa_real, fnventa_ppto),
      ventaCuotaAvg: calcPercentage(fnventa_real, fncuota_ventas),
      ventaAAAvg: calcPercentage(fnventa_real, fnventa_real_aa),
    };
  }, [salesData, hasError]);

  // Solo mostrar skeleton durante carga
  if (isLoading) {
    return <SkeletonSalesCard />;
  }

  // Siempre mostrar la tarjeta con datos (reales o en cero)
  return (
    <div className="container-table-sale">
      <header className="box-top-table-sale">
        <div className="box-sale-icon">
          <img className="IconImage" src={icons.sales} alt="Ventas" />
          <span className="box-sale-amount">Ventas</span>
        </div>
        <div className="title-top-table-indicadores-real">Real ${calculations.ventaReal}</div>
      </header>

      <div className="box-body-table-sale">
        <div className="item-box-table-sales1">
          <span className="text-vs">Vs Ptto</span>
          <p className="text-porcent">{calculations.ventaPttoAvg}%</p>
          <span className="text-presupues">${calculations.ventaPtto}</span>
        </div>

        <div className="item-box-table-sales">
          <span className="text-vs">Vs Cuota</span>
          <p className="text-porcent">{calculations.ventaCuotaAvg}%</p>
          <span className="text-presupues">${calculations.ventaCuota}</span>
        </div>

        <div className="item-box-table-sales3">
          <span className="text-vs">Vs AA</span>
          <p className="text-porcent">{calculations.ventaAAAvg}%</p>
          <span className="text-presupues">${calculations.ventaAA}</span>
        </div>
      </div>
    </div>
  );
};
